// extracted by mini-css-extract-plugin
export default {"Search":"search_Search__CjGzx","Light":"search_Light__j8WtZ"};